/* eslint-disable jira/filename-case */
import { isProjectsInJiraM2Enabled } from '@jira/platform__services-native-integration-projects/src/index.tsx';

export default {
	get(): boolean {
		return isProjectsInJiraM2Enabled();
	},
};
